import React from 'react'
import Navbar from './../../components/Navbar';
import CaseStudyTab from '../../components/CaseStudyTab';
import Footer from './../../components/Footer';
import ashoka from "../../assets/images/contents/case-study-ashoka.png"
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs';
import { useTranslation } from 'react-i18next';
import filter_color from "../../assets/images/design/colorFilter.svg"
import { StyledLink } from '../../components/StyledComponents';

const CaseStudyEducation = () => {
  const { t } = useTranslation()

  return (
    <div className='case-study-education bg-primary'>
      <div className='color-filter-left' style={{ left: "10%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "25%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid insurance-header pb-100'>
        <div className='container'>

          <div className='col-sm-10 col-sm-offset-1 pt-150'>
            <div className='font-weight-bold text-center font-64 insurance-header-title'>{t('case-study.education')}</div>
            <div className='col-sm-8 col-sm-offset-2'>
              <div className='underline-orange'></div>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-md-100 pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.case-studies')} currentPage={t('bread-crumbs.education')} linkToPrevPage="/case-study" />
          </div>
        </div>
      </div>
      <CaseStudyTab educationActive={true} />
      <div className='case-study-education-content container'>
        <div className='row'>
          <div className="col-lg-4">

            <div className='case-study-education-card'>
              <StyledLink href="/case-study/ashoka">
                <div className='case-study-education-card_image'>
                  <img src={ashoka} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip'>
                {t('case-study.education')}
              </div>
              <StyledLink href="/case-study/ashoka">
                <p className='text-white font-weight-semi-bold font-20'>{t('case-study.card-title-1')}</p>
              </StyledLink>
            </div>

          </div>

        </div>


      </div>
      {/* <div className='container'>
        <IndustriesImageContainer />
      </div> */}
      <Footer />
    </div >
  )
}

export default CaseStudyEducation